import axios from 'axios';
import {store} from "../App";
import {clearCruises, setCruises} from './cruisesActions';
import {getFromHub} from './networkActions';
import {updateBookings, updateCart} from './cartActions';
import {isCruiseStartDateDenied} from '../utils/dateTimeUtils';
import {updateItinerary} from "./itineraryActions";
import {getHubUrl, showExpiredTabMessage} from "../utils/configUtils";
import {removeLocalStorageState} from "../localStorage";
import {getEnvironment} from "../utils/themeUtils";


export function logoutAgency(forgetStore) {
    store.dispatch({type: "CLEAR_AGENCY_AUTHENTICATION"});
    logOutPassenger(true);
    if(forgetStore) {
        store.dispatch({type: "CLEAR_STORE"});
    }
}


//---

export function loginByPassenger(departureDate, bookingReference, lastName) {
    const bookingType = "OceanCruise";
    const brand = getEnvironment("BRAND");

    let request = {
        bookingReference,
        lastName,
        departureDate,
        bookingType,
        ...(brand && {brand})
    };

    return async function (dispatch, getStore) {
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };

        const isAgency = getStore().agency.isAuthenticated;

        if(isCruiseStartDateDenied(departureDate, isAgency)) {
            return false;
        }

        if (isAgency) {
            headers.SessionId = getStore().agency.sessionId;
        }

        return axios({
            method: 'POST',
            url: getHubUrl() + 'authentication/loginByPassenger',
            headers,
            data: JSON.stringify(request)
        })
        .then(function (response) {
            onLoginSuccess(dispatch, response.data);
            return true;
        })
        .catch(function (error) {
            dispatch({type: "SET_ERROR", message: error.message});
            return false;
        });
    }
}

//---

export function loginByToken(token, storeId) {
    let request = {
        token,
    };

    if(storeId) {
        request.externalId = storeId;
    }

    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    };

    return async function (dispatch) {
        return axios({
            method: 'POST',
            url: getHubUrl() + 'authentication/loginByToken',
            headers,
            data: JSON.stringify(request)
        })
        .then(function (response) {
            if (response.data.sessionType === "SingleSignOn") {
                logOutPassenger();
                dispatch({type: "SET_AGENCY_AUTHENTICATION", authentication: response.data});
            }
            else if (response.data.sessionType === "Passenger") {
                logoutAgency();
                onLoginSuccess(dispatch, response.data);
            }
            return true;
        })
        .catch(function (error) {
            dispatch({type: "SET_ERROR", message: error.message});
            return false;
        });
    };
}

export function onLoginSuccess(dispatch, data) {
    dispatch({type: "SET_AUTHENTICATION", authentication: data });
    getFromHub('prebooking/cruises', setCruises);
    updateCart();
    updateBookings();
    updateItinerary();
    if(showExpiredTabMessage()) {
        localStorage.setItem('authFlag', Date.now().toString());
    }
}

export async function logOutPassenger(clearLocalStorage = false) {
    await Promise.all([
        store.dispatch({type: "CLEAR_AUTHENTICATION"}),
        store.dispatch({type: "CLEAR_PAYMENT"}),
        store.dispatch({type: "CLEAR_CART"}),
        store.dispatch({type: "CLEAR_BOOKINGS"}),
        store.dispatch({type: "CLEAR_ITINERARY"}),
        store.dispatch({type: "CLEAR_SECTIONS"}),
        clearCruises(),
    ]);
    if(showExpiredTabMessage()) {
        localStorage.setItem('authFlag', Date.now().toString());
    }
    if(clearLocalStorage) {
        removeLocalStorageState();
    }
}



